<template>
  <div class="flex flex-col">
    <div class="my-2 -mx-4 overflow-x-auto sm:-mx-6 2xl:-mx-8 ">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 2xl:px-8">
        <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-300">

            <thead class="bg-gray-50 divide-y ">
              <template v-if="hasChildren">
                <template  v-for="(column, index) in header">
                  <colgroup v-if="index in itemsWithChildren" :key="`${column.title}_${index}`" :span="header[index].length"/>
                  <col v-else :key="column.title"/>
                </template>
              </template>
              <tr class="divide-x">
                <template v-for="column in header">
                  <th v-if="column.children === undefined" :rowspan="hasChildren ? 2 : 1" :key="column.title" class="px-3 py-3.5 text-center 2xl:text-sm sm:text-xl font-semibold text-gray-600">
                    {{ column.title}}
                  </th>
                  <th v-else :key="column.title" :colspan="column.children.length" class="px-3 py-3.5 text-center 2xl:text-sm sm:text-xl font-semibold text-gray-600">
                    {{ column.title}}
                  </th>
                </template>
              </tr>
              <template v-if="hasChildren">
                <tr class="" >
                  <template v-for="(children, index) in childrens">
                    <th :key="`${children.title}_${index}`" class="border border-inherit px-3 py-3.5 text-center 2xl:text-sm sm:text-xl font-semibold text-gray-600" scope="col">{{children.title}}</th>
                  </template>
                </tr>
              </template>

            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
              <tr v-for="(record, idx) in records" :key="idx">
                <template v-for="column in headerProcesed">

                  <td v-if="get_of_key(get_of_key(record, column.key, {}), 'renderer') === 'link'" :key="column.key" class="whitespace-nowrap px-3 py-4 2xl:text-sm sm:text-xl text-gray-500">
                      <a href="#" @click="linkClicked(record[column.key])" class="text-indigo-600 hover:text-indigo-900">{{ record[column.key].label }}</a>
                  </td>
                  <td v-else-if="get_of_key(get_of_key(record, column.key, {}), 'type') === 'action'"  :key="column.key" class="whitespace-nowrap px-3 py-4 2xl:text-sm sm:text-xl text-gray-500">
                      <template v-for="action in record[column.key].value">
                        <a :key="`${column.key}_${action.label}`"
                          href="#"
                          @click="runAction(record, action)"
                          class="text-indigo-600 hover:text-indigo-900 m-1">
                          {{ action.label }}
                        </a>
                      </template>
                  </td>

                  <td v-else-if="get_of_key(get_of_key(record, column.key, {}), 'renderer') === 'label'" :key="column.key" class="whitespace-nowrap px-3 py-4 2xl:text-sm sm:text-xl text-gray-500">
                    {{ record[column.key].label }}
                  </td>

                  <!-- <td v-else-if="typeof " :key="column.key" class="whitespace-nowrap px-3 py-4 2xl:text-sm sm:text-xl text-gray-500">{{ record[column.key] }}</td> -->
                  <td v-else :key="column.key" class="whitespace-nowrap px-3 py-4 2xl:text-sm sm:text-xl text-gray-500">{{ record[column.key] }}</td>
                  <!-- <td v-else :key="column.key" class="whitespace-nowrap px-3 py-4 2xl:text-sm sm:text-xl text-gray-500">{{ get_of_key(get_of_key(record, column.key, {}), 'value') }}</td> -->

                </template>

                <template v-if="field.actions !== false">
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right 2xl:text-sm sm:text-xl font-medium sm:pr-6">
                    <a @click="removeRecord(record.id)" class="text-indigo-600 hover:text-indigo-900">Eliminar</a>
                  </td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right 2xl:text-sm sm:text-xl font-medium sm:pr-6">
                    <a @click="editRecord(record.id)" class="text-indigo-600 hover:text-indigo-900">Editar</a>
                  </td>
                </template>
              </tr>

              <!-- More people... -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-end mt-2">
      <div>
        <nav class="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
          <a v-if="has_prev"
            @click="updatePage(prev)"
            class=" relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75" />
            </svg>
            <span class="sr-only">Previous</span>
          </a>
          <template v-if="pages>1">
            <template v-for="p in pages" >
              <a :key="p" v-if="p === page" aria-current="page" class="relative z-10 inline-flex items-center bg-indigo-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                {{p}}
              </a>
              <a :key="p" @click="updatePage(p)" v-else class="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
                {{p}}
              </a>
            </template>
          </template>

          <!-- Current: "z-10 bg-indigo-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600", Default: "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0" -->
          <a v-if="has_next"
            @click="updatePage(next)" class="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75" />
            </svg>
            <span class="sr-only">Next</span>
          </a>
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'complex-table-field',

  data() {
    return {
      header: [{}],
      records: [],
      currentformdata: {},
      childrens: [],
      hasChildren: false,
      itemsWithChildren: [],
      headerProcesed: [],

      pages: 1,
      page: 1,
      next: undefined,
      prev: undefined,
      has_next: false,
      has_prev: false,
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    formdata: {
      type: Object,
      required: true
    }
  },
  created() {
    this.getTable()
    this.checkDepends()
  },
  watch: {
    formdata: {
      deep: true,
      handler: async function(newVal)  {
        this.page = 1
        if (JSON.stringify(this.currentformdata) !== JSON.stringify(newVal)) {
          this.currentformdata = JSON.parse(JSON.stringify(newVal))
          this.getRecords()
        }
      }
    },
  },
  methods: {
    checkDepends() {
      this.getRecords()
    },
    async getTable() {
      let config = {
        params: {
          ...this.$store.state.data,
          table: this.field.key,
          blueprint: this.$route.params.blueprint,
          formdata: this.formdata
        }
      }
      const response = await this.$http.get(this.field.table, config)
      this.checkChildren(response.data)
      this.header = response.data

    },
    async updatePage(p){
      this.page = p
      await this.getRecords()
    },
    async getRecords() {
      let config = {
        params: {
          ...this.$store.state.data,
          id: this.$route.params.record,
          table: this.field.key,
          blueprint: this.$route.params.blueprint,
          formdata: this.formdata,
          page: this.page,
          per_page: this.get_of_key(this.get_of_key(this.field, 'options_paginator', {}), 'per_page', 15)
        }
      }
      const records = await this.$http.get(this.field.records, config)
      this.records = records.data.items
      /// Paginación
      this.pages = records.data.pages
      this.page = records.data.page
      this.next = records.data.next
      this.prev = records.data.prev
      this.has_next = records.data.has_next
      this.has_prev = records.data.has_prev
    },


    checkChildren(header){
      this.childrens = []
      header.forEach((item, i) => {
        if (typeof item.children !== 'undefined'){
            this.childrens = [...this.childrens, ...item.children.map(x => x)]
            this.headerProcesed = [...this.headerProcesed, ...item.children]
            this.itemsWithChildren = [...this.itemsWithChildren, i]
            this.hasChildren = true
          } else{
          this.headerProcesed = [...this.headerProcesed, item]
        }
      })
    },
    async linkClicked(link) {
      this.$router.push(link.url)
      this.$router.go()
    },
    async removeRecord(recordid) {
      let config = {
        params: {
          ...this.$store.state.data,
          recordid: recordid
        }
      }
      const response = await this.$http.get(`/flow/custom/removerecord`, config)
      console.log('removeRecord', response)
      this.getRecords()
    },
    goToForm(record, action){
      this.$store.commit('setState', {record: record})
      this.$router.push(action.url)
      this.$router.go()
    },
    async runAction (record, action) {
      if (action.action === 'goToForm'){
        this.goToForm(record, action)
      } else if (action.action === 'runInForm') {
        await this[action.function](record.id)
      } else if (action.action === 'runInApi') {
        this.runInApi(record, action)
      } else {
        console.log("No se ha ejecutado nada");
      }
    },
    async runInApi(record, action){
      console.log('runInApi')
      console.log(record);
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        },
        params: {
          ...this.params,
          blueprint: this.$route.params.blueprint,
          record: this.$route.params.record,
          query: {...this.$route.query, ...action.params}
        }
      }

      const response = await this.$http.get(action.url, config)
      if (response.data.push !== undefined){
        console.log(response.data);
        this.$router.push(response.data.push)
        this.$router.go()
      }else{
        this.getRecords()
      }

    },
    editRecord(recordid) {
      // XXX: Esto está fijo, me parece que es arte de CMPC
      this.$router.push('/form/5/' + recordid)
      this.$router.go()
    },
    get_of_key(obj, key, default_value = undefined){
      const response = (typeof obj[key]!== "undefined") ? obj[key] : default_value
      return response

    },
    validateIsAction(record, column) {
      if (typeof record[column.key] !== undefined){
        if (record[column.key].type === 'action'){
          return true
        }
      }
      return false
    }

  }
}
</script>
